import { schema } from 'normalizr';

export default new schema.Entity(
  'favourites',
  {},
  {
    idAttribute: 'id',
  }
);
